import { SHORTCUT_BUSINESS_PROFILES_FIELDS } from '@@partner:graphql/shortcuts'
import { BusinessProfile, BusinessProfileBankDetails } from '@@partner:types:app'
import { GQL_ID } from '@@partner:types:graphql'
import { gql, useMutation } from '@apollo/client'

export interface BusinessProfileInput {
  id?: GQL_ID
  owner_id: GQL_ID | null
  name: string
  address: string
  director?: string
  phone_number?: string
  status: string
  require_invoice: boolean
  vat_enabled: boolean
  bankDetails: BusinessProfileBankDetails
}

export interface SaveBusinessProfile {
  businessProfile: BusinessProfile
}

export interface SaveBusinessProfileVariables {
  businessProfileInfo: BusinessProfileInput
  id: GQL_ID
  activate?: boolean
}

export const GQL_MUTATION_SAVE_BUSINESS_PROFILE = gql`
  mutation ($id: ID!, $businessProfileInfo: UpdateBusinessProfileInput!, $activate: Boolean) {
    businessProfile: updateBusinessProfile(id: $id, businessProfileInfo: $businessProfileInfo, activate: $activate) {
      ${SHORTCUT_BUSINESS_PROFILES_FIELDS}
    }
  }
`

export const useMutateSaveBusinessProfile = () => useMutation<SaveBusinessProfile, SaveBusinessProfileVariables>(GQL_MUTATION_SAVE_BUSINESS_PROFILE)